<template>

  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Design</h2>
      <p class='text-white'>Customise your websites brand</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Colours" class="mb-4">
        Select an existing colour scheme or customise your own. These brand colours are automatically used in your website to keep it consistent.
      </b-card>
      <b-card title="Styles" class="mb-4">
        Select your fonts to be used in across your website.
      </b-card>
      <b-card title="Logo" class="mb-4">
        Use the logo creator or upload your own.
      </b-card>
    </b-container>
  </b-container>

  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Design</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
        </b-col>
      </b-row>
      <!--  -->
      <b-nav>
        <b-nav-item :to="{name: 'colours'}" exact exact-active-class="tab_active">Colours</b-nav-item>
        <b-nav-item :to="{name: 'styles'}" exact exact-active-class="tab_active">Styles</b-nav-item>
        <b-nav-item :to="{name: 'logo'}" exact exact-active-class="tab_active">Logo</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" class='mb-4'/>
  </b-container>
</template>

<script>
import { db } from '@/main.js'

export default {
  name: 'site_links',
  props: ['profile', 'user', 'site'],
  data() {
    return {
      help: this.site.help.design
    }
  },
  watch: {
    help(val) {
      if (this.site.help.design && !val) {
        db.collection('site').doc(this.site.id).update({'help.design': false})
      }
    }
  },
}
</script>

<style>

</style>
